import script from "./EditUserRolesDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditUserRolesDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditUserRolesDialog.vue?vue&type=style&index=0&id=d1e68b18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1e68b18"]])

export default __exports__